
import React, { useState, useEffect } from 'react';
import { Toaster } from '@/components/ui/toaster';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { ActionGrid } from '@/components/actions/ActionGrid';
import { BarometerPopup } from '@/components/actions/BarometerPopup';
import { ICFAnnouncementCard } from '@/components/actions/ICFAnnouncementCard';
import { ExprimeCharteCard } from '@/components/actions/ExprimeCharteCard';
import { useLocation } from 'react-router-dom';
import { Seo } from "@/components/Seo";

const Actions = () => {
  const [showBarometerPopup, setShowBarometerPopup] = useState(false);
  const location = useLocation();

  // Log when component mounts or updates
  useEffect(() => {
    console.log('[DEBUG Actions] Component mounted/updated', { 
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      from: document.referrer || 'direct navigation',
      hostname: window.location.hostname,
      href: window.location.href
    });
  }, [location]);

  const handleBarometerButtonClick = () => {
    console.log('Barometer button clicked');
    setShowBarometerPopup(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFFD4C] via-[#FFFD4C] to-[#F5E84A]">
      <Seo title="Nos actualités et actions | Enfants de la République" description="Découvrez les initiatives, actualités et actions de l'association Enfants de la République pour la citoyenneté et les valeurs républicaines." path="/actions" />
      <Header />
      <section className="relative pt-24 pb-8 md:pt-28 md:pb-12 overflow-hidden">
        <div className="container max-w-6xl mx-auto px-4 relative z-10">
          <div className="mb-6">
            <h1 className="text-2xl sm:text-3xl font-bold text-[#1E3A8A] animate-fade-in">Nos actualités et actions</h1>
          </div>

          <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A8A] mb-4">Nos initiatives</h2>

          <div className="space-y-6">

            <ICFAnnouncementCard />
            <ExprimeCharteCard />
            <ActionGrid 
              onShowBarometerPopup={handleBarometerButtonClick}
            />
          </div>
        </div>
      </section>

      {/* Popups using Dialog component from shadcn */}
      <BarometerPopup
        isVisible={showBarometerPopup} 
        onClose={() => setShowBarometerPopup(false)} 
      />

      <Footer />
      <Toaster />
    </div>
  );
};

export default Actions;
